module.exports = __webpack_public_path__ + "static/media/banner_420x230_8.d221ba56.jpg";